import { useEffect, useState } from "react";
import SignupForm from "./SignupForm";
import PlanLayout from "../PlanLayout";
import { getPlan } from "@/api/billing";
import { RecurlyPlan } from "@/lib/recurly";
import { useLocation, useSearch } from "wouter";
import PageLoader from "@/components/PageLoader";

export default function SignupPage() {
  const searchParams = new URLSearchParams(useSearch());
  const [location, navigate] = useLocation();
  const [plan, setPlan] = useState<RecurlyPlan | null>(null);

  // these are query params that will be present if this user got here from an affiliate link.
  const [psPartnerKey, setPSPartnerKey] = useState<string | null>(null);
  const [ps_xid, setPs_xid] = useState<string | null>(null); // click id.

  const findPlan = (param: string) => {
    const possiblePlans = [
      "launch-special-monthly",
      "launch-special-annual",
      "professional-997-webinaroffer",
      "professional-launch-annual-inapp",
      "professional-launch-monthly-inapp",
      "standard-launch-annual-inapp",
      "standard-launch-monthly-inapp",
      "standard-monthly-launchspecial",
      "standard-annual-launchspecial",
      "professional-monthly-launchspecial",
      "professional-annual-launchspecial",
      "standard-webinaroffer",
      "professional-webinaroffer",
      "professional-roadmap-annual",
      "professional-roadmap-monthly",
      "standard-roadmap-annual",
      "standard-roadmap-monthly",

      // go aura integration:
      "professional-monthly-integration",
      "professional-annual-integration",
      "standard-monthly-integration",
      "standard-annual-integration",
    ];

    //If the plan param that was passed in is found in the list above then return it from the function.
    if (possiblePlans.findIndex(plan => plan === param) !== -1) {
      return param;
    }

    //Default the plan to the "standard-launch-monthly-inapp" if the plan param was invalid.
    //Also need to make sure we preserve the other search params that were provided.
    const params = new URLSearchParams();
    params.append("plan", "standard-launch-monthly-inapp");

    if (!!searchParams.get("ps_xid")) {
      params.append("ps_xid", searchParams.get("ps_xid"));
    }

    if (!!searchParams.get("ps_partner_key")) {
      params.append("ps_partner_key", searchParams.get("ps_partner_key"));
    }

    navigate(`~/auth/signup?${params.toString()}`);

    return "standard-launch-monthly-inapp";
  };

  useEffect(() => {
    getPlan(findPlan(searchParams.get("plan"))).then(planRes => setPlan(planRes));
    setPs_xid(searchParams.get("ps_xid"));
    setPSPartnerKey(searchParams.get("ps_partner_key"));
  }, []);

  if (plan === null) {
    return <PageLoader />;
  }

  return (
    <PlanLayout plan={plan}>
      <SignupForm xid={ps_xid} />
    </PlanLayout>
  );
}
